//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TableSkelenton from "@/components/Skeletons/TableSkeleton"
import UsuarioTareas from '@/api/promotores/usuarios/tareas.api'
import apiTagsUser from "@/api/promotores/usuarios/tags.api";

export default {
  components: {
    TableSkelenton,
  },
  data() {
    return {
      cierralo_tu: false,
      tempCierraloTu: false,
      tags: [],
      per_page_options: [10, 20, 30, 40, 50, 100],
      columns: [
        {
          name: "solicitud",
          label: "Solicitud ID",
          field: "solicitud_id",
          align: "left",
          classes: "bg-grey-2 ellipsis",
          style: "width: 350px",
          headerClasses: "bg-primary text-white",
        },
        {
          name: "calificacion",
          label: "Calificación",
          field: "calificacion",
          sortable: true,
        },
        {
          name: 'status',
          label: 'Status',
          field: 'status',
          align: 'left'
        },
        {
          name: "creacion",
          label: "Creación",
          field: "created_at",
          sortable: true,
          // format: this.momentFromNow,
        },
      ],
      solicitudes: [],
      status: [
        { value: 'en espera', label: 'En espera' },
        { value: 'procede', label: 'Procede' },
        { value: 'completado', label: 'Completado' },
        { value: 'cancelado', label: 'Cancelado' },
        { value: 'rollback', label: 'Rollback' },
      ],
      loading: false,
    }
  },

  mounted() {
    this.loadTareas()
    this.checkCierraloTuTag()
  },

  methods: {
    async checkCierraloTuTag() {
      this.tags = await apiTagsUser.all(this.$route.params.promotor)
      const cierralo = this.tags.find(tag => tag.slug === 'tareas-cierralo-tu')
      this.cierralo_tu = !!cierralo
      this.tempCierraloTu = this.cierralo_tu;
    },
    toggleConfirmation() {
      if (this.tempCierraloTu !== this.cierralo_tu) {
        const message = this.tempCierraloTu
          ? 'Seguro de querer continuar, el promotor dejará de ver las Tareas de Ciérralo Tú.'
          : 'Seguro de querer continuar, el promotor podrá ver las Tareas de Ciérralo Tú.';

        this.$q.dialog({
          title: 'Mensaje importante',
          message: message,
          html: true,
          ok: {
            push: true,
          },
          persistent: true,
          cancel: true
        })
          .onOk(() => {
            this.updateCierraloTuTag(this.tempCierraloTu);
          })
          .onCancel(() => {
            this.tempCierraloTu = this.cierralo_tu;
          });
      }
    },
    async updateCierraloTuTag(value) {
      if (value) {
        await apiTagsUser.add(this.$route.params.promotor, 19);
      } else {
        await apiTagsUser.delete(this.$route.params.promotor, 19);
      }
      // Actualizar el valor final del toggle después de confirmar la acción
      this.cierralo_tu = value;
    },
    async loadTareas() {
      this.loading = true
      try {
        this.solicitudes = await UsuarioTareas.all(this.$route.params.promotor)

        this.solicitudes
          .filter((solicitud) => solicitud.calificacion == null)
          .map((solicitud) => {
            solicitud.calificacion = 0
            return solicitud
          })
      } finally {
        this.loading = false
      }
    },
    rowClick({ solicitud_id }) {
      window.open(process.env.VUE_APP_SERVICIOS_WEB + "/operacion/detalles/" + solicitud_id, "_blank")
    },
    async rating(tarea) {
      await UsuarioTareas.update(this.$route.params.promotor, tarea._id, { calificacion: tarea.calificacion })
      this.loadTareas()
    },
    async updateTarea(tarea) {
      await UsuarioTareas.update(this.$route.params.promotor, tarea._id, { status: tarea.status })
      this.loadTareas()
    },
  },
}
